<template>
  <div class="view">
    <div class="title5">
      <div class="title5l">选择表单模版</div>
      <el-button type="primary" round size="medium" @click="goedit">使用此模版</el-button>
    </div>
    <el-container class="mobanindex">
      <el-main class="mobanleft">
        <div class="mobanleftbox formdesign formbigbox">
          <div class="control-title"><p>{{formdata.title || '自定义表单'}}</p><img src="/static/img/menu.png" /></div>
          <div class="design-phone">
            <div class="design-scroll">
              <div class="design-body">  
                <div class="design-banner">
                  <img :src="formdata.back_img" alt />
                  <div class="design-banner-txt" v-if="formdata.title_show">{{formdata.title}}</div>
                </div>            
                <div class="design_edit">
                  <div
                    class="design_item"
                    v-for="(item,index) in designviews"
                    :key="index"
                    @click.stop="choosedesign(item,index)"
                    :draggable="item.draggable"
                  >
                    <div class="design_tool">
                      <component v-bind:is="item.template" :property="item.content"></component>
                    </div>
                  </div>
                </div>
                <div class="formsubmit">
                  <div class="btn1">提交</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-aside width="520px">
        <div class="tab5">
          <el-radio-group v-model="tabdata.form_type" @change="radioChange" size="small">
            <el-radio-button label="0">全部</el-radio-button>
            <el-radio-button label="1">会员信息</el-radio-button>
            <el-radio-button label="2">招商加盟</el-radio-button>
            <el-radio-button label="3">客户信息</el-radio-button>
            <el-radio-button label="4">活动报名</el-radio-button>
            <el-radio-button label="-1">历史表单</el-radio-button>
          </el-radio-group>
        </div>
        <div class="form-nodata" v-if="mobanlist.length==0">
          暂无相关模版~
        </div>
        <div class="mobancon">
          <div
            class="item"
            v-if="tabdata.form_type==0"
            :class="isdefault?'on':''"
            @click="morentap"
          >
            <div class="imgbox imgbox1">
              <i class="el-icon-plus"></i>
            </div>
            <p>自定义表单</p>
          </div>
          <div
            class="item"
            v-for="(item,index) in mobanlist"
            :key="index"
            @click="choose(index,item.id)"
            :class="formidx==index?'on':''"
          >
            <div class="imgbox">
              <img :src="item.back_img" alt />
            </div>
            <p>{{item.title}}</p>
          </div>
        </div>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import api from "@/api.js";
import draggable from "vuedraggable";
import datetool from "@/components/formtools/date.vue"; // 日期
import dateProperty from "@/components/formtools/dateProperty.vue";
import multiCheck from "@/components/formtools/multiCheck.vue";
import multiCheckProperty from "@/components/formtools/multiCheckProperty.vue";
import multiText from "@/components/formtools/multiText.vue";
import multiTextProperty from "@/components/formtools/multiTextProperty.vue";
import selecttool from "@/components/formtools/select.vue";
import selectProperty from "@/components/formtools/selectProperty.vue";
import selectProvinces from "@/components/formtools/selectProvinces.vue";
import selectProvincesProperty from "@/components/formtools/selectProvincesProperty.vue";
import singleCheck from "@/components/formtools/singleCheck.vue";
import singleCheckProperty from "@/components/formtools/singleCheckProperty.vue";
import singleText from "@/components/formtools/singleText.vue";
import singleTextProperty from "@/components/formtools/singleTextProperty.vue";
import timetool from "@/components/formtools/time.vue";
import timeProperty from "@/components/formtools/timeProperty.vue";
import uploadtool from "@/components/formtools/upload.vue";
import uploadProperty from "@/components/formtools/uploadProperty.vue";
import formtitle from "@/components/formtools/formtitle.vue";
import formtitleProperty from "@/components/formtools/formtitleProperty.vue";
import placeholder from "@/components/formtools/placeholder.vue";
import placeholderProperty from "@/components/formtools/placeholderProperty.vue";
import { yeartime } from "@/assets/js/common";
import { pagination } from "@/util/util.js";
export default {
  name: "formAdd",
  components: {
    placeholder,
    placeholderProperty,
    formtitle,
    formtitleProperty,
    multiText,
    multiTextProperty,
    draggable,
    datetool,
    dateProperty,
    multiCheck,
    multiCheckProperty,
    multiText,
    multiTextProperty,
    selecttool,
    selectProperty,
    selectProvinces,
    selectProvincesProperty,
    singleCheck,
    singleCheckProperty,
    singleText,
    singleTextProperty,
    timetool,
    timeProperty,
    uploadtool,
    uploadProperty
  },
  data() {
    return {
      tabdata: {
        form_type: 0
      },
      formid:0,
      currentindex: "",
      currentview: null,
      designviews: [],
      isdefault: true,
      mobanlist: [],
      formdata: {},
      formidx: -1
    };
  },
  created() {
    const loading = this.$loading({
      lock: true,
      text: "加载中…",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.4)",
      customClass: "fontColor"
    });
    this.InitFn(loading);
  },
  methods: {
    InitFn(loading) {
      // 创建执行
      this.axios
        .post(api.companyadmin_form_moban, this.tabdata)
        .then(response => {
          if (response.data.code == 0) {
            for (let i in response.data.list) {
              if(response.data.list[i].id==this.formid){
                this.formidx=i
              }
            }
            this.mobanlist = response.data.list;
            loading.close();
          } else {
          }
        })
        .catch(() => {});
    },
    radioChange(option) {
      // 选择radio
      this.tabdata.form_type = option;
      this.InitFn();
    },
    morentap() {
      this.isdefault = true;
      this.formidx = -1;
      this.formdata={}
      this.designviews=[]
      this.formid=0
    },
    choose(idx, id) {
      this.isdefault = false;
      this.formidx = idx;
      this.formid = id;
      this.axios
        .post(api.companyadmin_form_detail, {
          form_id: id
        })
        .then(response => {
          if (response.data.code == 0) {
            this.formdata = response.data.info;
            this.designviews=[]
            let list_line = response.data.info.page_content;
            if (list_line.length !== 0) {
              for (let i in list_line) {
                this.gettool("edit", list_line[i].type, list_line[i].content);
              }
              this.currentindex = 0;
              this.currentview = this.designviews[0];
            } else {
              this.designviews = [];
              this.currentview = null;
            }
          } else {
          }
        })
        .catch(() => {});
    },
    gettool(type, typeNumber, option) {
      // type add 添加 edit 编辑 option编辑的内容
      let currentview = null;
      switch (typeNumber) {
        case 1: // 单行文本
          currentview = this.getline1(type, option);
          break;
        case 2: // 多行文本
          currentview = this.getline2(type, option);
          break;
        case 3: // 标题
          currentview = this.gettitle(type, option);
          break;
        case 4: // 时间
          currentview = this.gettime(type, option);
          break;
        case 5: //日期
          currentview = this.getdate(type, option);
          break;
        case 6: // 下拉框
          currentview = this.getselect(type, option);
          break;
        case 7: // 单项选择
          currentview = this.getcheck1(type, option);
          break;
        case 8: // 多项选择
          currentview = this.getcheck2(type, option);
          break;
        case 9: // 上传图片
          currentview = this.getimg(type, option);
          break;
        case 10: //省市区
          currentview = this.getpro(type, option);
          break;
        case 11: // 占位符
          currentview = this.getplace(type, option);
          break;
      }
      for (let i in this.designviews) {
        if (this.designviews[i].draggable) {
          this.designviews[i].draggable = false;
        }
      }
      if (type === "add") {
        this.showall = 1;
        currentview.draggable = true; // 显示
        if (this.currentindex !== null) {
          this.designviews.splice(this.currentindex + 1, 0, currentview);
          this.currentindex = this.currentindex + 1;
          this.currentview = currentview;
        } else {
          this.designviews.push(currentview);
          this.currentindex = this.designviews.length - 1;
          this.currentview = currentview;
        }
      } else {
        this.designviews.push(currentview);
      }
    },
    //当行文本
    getline1(type, option) {
      let content_ = {
        type: 1,
        template: "singleText",
        propertytype: "singleTextProperty",
        content: {
          name: "手机号",
          radio: 1,
          radio2: 2,
          num: 15,
          checked: true
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },

    //多行文本
    getline2(type, option) {
      let content_ = {
        type: 2,
        template: "multiText",
        propertytype: "multiTextProperty",
        content: {
          name: "多行文本",
          checked: false,
          num: 300
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 标题
    gettitle(type, option) {
      let content_ = {
        type: 3,
        template: "formtitle",
        propertytype: "formtitleProperty",
        content: {
          title: "标题栏"
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    //时间
    gettime(type, option) {
      let content_ = {
        type: 4,
        template: "timetool",
        propertytype: "timeProperty",
        content: {
          name: "时间"
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 日期
    getdate(type, option) {
      let content_ = {
        type: 5,
        template: "datetool", // 类型
        propertytype: "dateProperty",
        content: {
          name: "日期"
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 下拉框
    getselect(type, option) {
      let content_ = {
        type: 6,
        template: "selecttool", // 类型
        propertytype: "selectProperty",
        content: {
          name: "下拉框",
          list: [],
          checked: false
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 单项选择
    getcheck1(type, option) {
      let content_ = {
        type: 7,
        template: "singleCheck", // 类型
        propertytype: "singleCheckProperty",
        content: {
          radio: 1,
          name: "自定义",
          list: [],
          checked: false
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 多项选择
    getcheck2(type, option) {
      let content_ = {
        type: 8,
        template: "multiCheck", // 类型
        propertytype: "multiCheckProperty",
        content: {
          name: "多项选择",
          list: [],
          checked: false
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 选择省市区
    getimg(type, option) {
      let content_ = {
        type: 9,
        template: "uploadtool", // 类型
        propertytype: "uploadProperty",
        content: {
          name: "上传图片",
          num: 4,
          checked: false
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    // 选择省市区
    getpro(type, option) {
      let content_ = {
        type: 10,
        template: "selectProvinces", // 类型
        propertytype: "selectProvincesProperty",
        content: {
          name: "地区",
          radio: 1,
          checked: false
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    getplace(type, option) {
      let content_ = {
        type: 11,
        template: "placeholder", // 类型
        propertytype: "placeholderProperty",
        content: {
          height: 30,
          radio: 1
        }
      };
      if (type === "edit") {
        content_.content = option;
      }
      return content_;
    },
    goedit() {
       this.axios
        .post(api.companyadmin_form_use,{template_id:this.formid})
        .then(response => {
          if (response.data.code == 0) {
  this.$router.push({
        name: "formEdit",
        query: { id:response.data.form_id}
      });
          } else {
          }
        })
        .catch(() => {});
    
    },
    choosedesign(){
      
    }
  }
};
</script>
<style>
.homeHeight {
  display: none;
}
</style>
